import Vue from 'vue';
import { BModal } from 'bootstrap-vue';

const AlertConstructor = Vue.extend({
  components: { BModal },
  data() {
    return {
      visible: false,
      message: '',
      title: '',
      actionLabel: '',
      actionHandler: null,
      secondaryActionLabel: '',
      secondaryActionHandler: null,
    };
  },
  methods: {
    show(message, title = 'Uyarı', options = {}) {
      this.message = message;
      this.title = title;
      this.actionLabel = options.actionLabel || '';
      this.actionHandler = typeof options.actionHandler === 'function' ? options.actionHandler : null;
      this.secondaryActionLabel = options.secondaryActionLabel || '';
      this.secondaryActionHandler = typeof options.secondaryActionHandler === 'function' ? options.secondaryActionHandler : null;
      this.visible = true;
    },
    hide() {
      this.visible = false;
      // Reset action so the next plain alert doesn't keep an extra button
      this.actionLabel = '';
      this.actionHandler = null;
      this.secondaryActionLabel = '';
      this.secondaryActionHandler = null;
    },
    runAction() {
      const handler = this.actionHandler;
      this.hide();
      if (handler) {
        handler();
      }
    },
    runSecondaryAction() {
      const handler = this.secondaryActionHandler;
      this.hide();
      if (handler) {
        handler();
      }
    },
  },
  render(h) {
    const formattedMessage = (this.message || '').replace(/\n/g, '<br>');
    const buttons = [
      h(
          'b-button',
          {
            props: { variant: 'danger' },
            on: { click: this.hide },
            class: 'mx-1',
          },
          'Tamam'
      ),
    ];

    if (this.secondaryActionLabel && this.secondaryActionHandler) {
      buttons.push(
          h(
              'b-button',
              {
                props: { variant: 'success' },
                on: { click: this.runSecondaryAction },
                class: 'mx-1',
              },
              this.secondaryActionLabel
          )
      );
    }

    if (this.actionLabel && this.actionHandler) {
      buttons.push(
          h(
              'b-button',
              {
                props: { variant: 'primary' },
                on: { click: this.runAction },
                class: 'mx-1',
              },
              this.actionLabel
          )
      );
    }

    return h(
        'b-modal',
        {
          props: {
            id: 'global-alert-modal',
            visible: this.visible,
            title: this.title,
            centered: true,
            hideFooter: true,
          },
          on: {
            hidden: this.hide,
          },
          ref: 'modal',
        },
        [
          h('div', { class: 'text-center' }, [
            h('p', {
              class: 'font-weight-bold text-dark',
              domProps: {
                innerHTML: formattedMessage,
              },
            }),
            h('div', { class: 'd-flex justify-content-center flex-wrap', style: 'gap: 8px;' }, buttons),
          ]),
        ]
    );
  },
});

let instance;

const showAlert = function (vm, message, title = 'Uyarı', options = {}) {
  if (!instance) {
    const AlertComponent = new AlertConstructor({ parent: vm });
    instance = AlertComponent.$mount();
    document.body.appendChild(instance.$el);
  }

  instance.show(message, title, options);
};

export default {
  install(Vue) {
    Vue.prototype.$alert = showAlert;
  },
};
